import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CustomerDashboardGeneralComponent } from './view/customer-dashboard-general/customer-dashboard-general.component';
import { EditCustomerComponent } from './components/edit-customer/edit-customer.component';
import { EditorAccessGuard } from 'src/app/guards/editor-access.guard';
import { LeadGenerateComponent } from './components/service-agreement/lead-generate/lead-generate.component';
import { CheckoutComponent } from './components/service-agreement/checkout/checkout.component';
import { CheckoutGuard } from 'src/app/guards/checkout.guard';
import { AddClaimComponent } from './components/add-claim/add-claim.component';
import { ViewClaimComponent } from './components/view-claim/view-claim.component';
import { ViewAgreementComponent } from './components/view-agreement/view-agreement.component';
import { ClaimStatusComponent } from './components/grids/claims/claim-status/claim-status.component';

const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    component: CustomerDashboardGeneralComponent,
  },
  {
    path: 'edit',
    component: EditCustomerComponent,
    canActivate:[EditorAccessGuard],
  },
  {    
    path: 'add-agreement',
    pathMatch: 'full',
    component: LeadGenerateComponent,
    canActivate:[EditorAccessGuard],
  },
  {    
    path: 'checkout',
    pathMatch: 'full',
    component: CheckoutComponent,
    canActivate:[CheckoutGuard],
  },
  {
    path: 'file-a-claim',
    pathMatch: 'full',
    component: AddClaimComponent,
    canActivate:[EditorAccessGuard],
  },
  {
    path: 'view-claim/:claimId',
    pathMatch: 'full',
    component: ViewClaimComponent,
    canActivate:[EditorAccessGuard],
  },
  {
    path: 'view-agreement/:agreementId',
    pathMatch: 'full',
    component: ViewAgreementComponent,
    canActivate:[EditorAccessGuard],
  },
  {
    path: 'claim-status/:claimId',
    pathMatch: 'full',
    component: ClaimStatusComponent,
    canActivate:[EditorAccessGuard],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: [EditorAccessGuard],
})
export class CustomerDashboardRoutingModule { }
